import { ITextBoxItemBean } from "../../../infrastructure/document/ver2/beans/items";
import { ScreenKinds } from "../../his/behavior";
import { TextBoxInputMethodKinds } from "../inputMethodKinds";
import { RelationalActionKinds } from "..";

export type TextBoxInputMethodOptionKinds
  = "Normal"           // 通常
  | "HisItem"          // HIS項目（フリー入力不可）
  | "HisFreeInput"     // HIS項目（フリー入力可能）
  | "HisInfoSelect"    // HIS情報選択(HIS項目で選択画面があるもの)
  | "UserDefinition"   // ユーザ定義
  | "MKSTemplate"      // MKSテンプレート
  | "DynamicTemplate"; // DYNAMICテンプレート

const deciders: { [K in TextBoxInputMethodOptionKinds]: (bean: ITextBoxItemBean) => boolean } = {
  Normal:          undefined, // otherwiseで返すので定義しない
  HisItem:         bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType === ScreenKinds.None && !bean.supportedFreeText),
  HisFreeInput:    bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType === ScreenKinds.None && bean.supportedFreeText),
  HisInfoSelect:   bean => (bean.hisItemParameter != null && bean.hisItemParameter.screenType !== ScreenKinds.None),
  UserDefinition:  bean => (bean.sourceFile != null),
  MKSTemplate:     bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.MksTemplateFormat)),
  DynamicTemplate: bean => (bean.relationalItems && !!bean.relationalItems.find(i => i.relationalActionType === RelationalActionKinds.DynamicTemplateFormat)),
};

const defaultInputMethodKinds: { [K in TextBoxInputMethodOptionKinds]: TextBoxInputMethodKinds } = {
  Normal:          TextBoxInputMethodKinds.None,
  HisItem:         TextBoxInputMethodKinds.None,
  HisFreeInput:    TextBoxInputMethodKinds.None,
  HisInfoSelect:   TextBoxInputMethodKinds.HisInfoSelect,
  UserDefinition:  TextBoxInputMethodKinds.UserDefinitionSelect,
  MKSTemplate:     TextBoxInputMethodKinds.MKSTemplate,
  DynamicTemplate: TextBoxInputMethodKinds.DynamicTemplate,
};

const hasDictionaryProperty = (key: string): key is TextBoxInputMethodOptionKinds => deciders.hasOwnProperty(key);

export namespace TextBoxInputMethodOptionKinds {
  export const Normal: TextBoxInputMethodOptionKinds = "Normal";
  export const HisItem: TextBoxInputMethodOptionKinds = "HisItem";
  export const HisFreeInput: TextBoxInputMethodOptionKinds = "HisFreeInput";
  export const HisInfoSelect: TextBoxInputMethodOptionKinds = "HisInfoSelect";
  export const UserDefinition: TextBoxInputMethodOptionKinds = "UserDefinition";
  export const MKSTemplate: TextBoxInputMethodOptionKinds = "MKSTemplate";
  export const DynamicTemplate: TextBoxInputMethodOptionKinds = "DynamicTemplate";

  export const toInputMethodOptionKinds = (bean: ITextBoxItemBean): TextBoxInputMethodOptionKinds => {
    for (const key in deciders) {
      if (hasDictionaryProperty(key) && deciders[key] != null && deciders[key](bean)) {
        return key;
      }
    }
    return Normal;
  };

  export const getDefualtInputMethodKind = (optionKind: TextBoxInputMethodOptionKinds): TextBoxInputMethodKinds => {
    return defaultInputMethodKinds[optionKind];
  };
}
